import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { TRANSCRIPT_ROUTES } from "TranscriptsV3/modules/constants";

export default store => ({
  path: `${TRANSCRIPT_ROUTES.YEAR_GROUPS}/:yearGroupId`,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-v3-year-group-details" */ "./components"
    ).then(m => m.default)
  ),
});
